import React, { useContext } from 'react';
import {
    GeoJSONPoint,
    calculatePolygonCenter,
    convertPathsArrayToGeoJSON,
    isValidPolygon,
    // wrap
} from './GeofenceManager/GeofenceManager.helpers';
import GeofenceControls from './GeofenceManager/GeofenceControls';
import { MapContext } from './MapContext';

// Polygon creation was removed when Google deprecated the Maps DrawingManager
// (unavailable as of Maps JS API v3.65). Only circle geofences can be created
// (see GeofenceMap's map-click handler); existing polygons still render and
// remain editable via core Maps, so handleShapeChange keeps its polygon branch.
const useDrawingManager = ({ canEdit }) => {
    const { fences, setError } = useContext(MapContext);

    const handleShapeChange = (shapeType, index) => {
        const newGeofence = {};
        const { instance } = fences[index];
        if (shapeType === 'radialGeofence') {
            if (!instance?.getRadius) return;
            const newCenter = instance?.getCenter().toJSON();
            const newRadius = instance?.getRadius();
            if (newRadius) {
                newGeofence.radius_meters = newRadius;
            }
            if (newCenter) {
                newGeofence.center = GeoJSONPoint([Number(newCenter.lng), Number(newCenter.lat)]);
            }
        } else if (shapeType === 'polygonalGeofence') {
            if (!instance?.getPath) return;
            const newPathsArray = instance?.getPath()?.getArray();
            const { valid, error } = isValidPolygon(newPathsArray);
            if (!valid) {
                setError(error);
            } else {
                setError();
            }
            const newCenter = calculatePolygonCenter(newPathsArray.map((path) => path.toJSON()));
            newGeofence.geometry = GeoJSONPoint(convertPathsArrayToGeoJSON(newPathsArray, true), 'Polygon');
            newGeofence.center = GeoJSONPoint([Number(newCenter.lng), Number(newCenter.lat)]);
        }
        return newGeofence;
    };

    const DrawingControls = <GeofenceControls canEdit={canEdit} />;

    return { DrawingControls, handleShapeChange };
};

export default useDrawingManager;
